<template>
  <v-app>
    <mts-loading fullscreen v-bind:visible="loading === 'PENDING'" />

    <main-preload 
      v-if="loading === 'READY' && showTermsOfUseModal" 
      v-on:submit="onSubmit" />

    <v-container v-if="loading === 'READY' && !showTermsOfUseModal" fluid class="pa-0 ma-0" fill-height d-block>
      <app-header v-if="isBlocked" />

      <div
        class="content"
        v-bind:class="{ nf : isNotFound, 'pb-log' : isUserLogist }">
        <router-view />
      </div>
    </v-container>
  </v-app>
</template>

<script>
  import Header from '@/components/Header.vue';
  import MainPreload from '@/views/MainPreload.vue';

  import { mapState } from 'vuex';
  
  export default {
    components: {
      appHeader: Header,
      MainPreload
    },
    data() {
      return {
        loading: 'INITIAL',
        showTermsOfUseModal: false
      };
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      isNotFound() {
        return this.$route.name === '404';
      },
      isBlocked() {
        return this.$route.name !== '403';
      },
      isUserLogist() {
        if (this.user.userInfo && this.user.userInfo.roles) {
          return this.user.userInfo.roles.map(item => item.code).includes('LOGIST');
        }
        return false;
      }
    },
    async created() {
      this.loading = 'PENDING';

      try {
        const { data: { terms_of_use: termsOfUse } } = await this.$http.get('/api/v1/user/profile');

        if (!termsOfUse) {
          this.showTermsOfUseModal = true;
        }
      } catch (e) {
        //
      } finally {
        this.loading = 'READY';
      }
    },
    methods: {
      async onSubmit() {
        try {
          await this.$http.put('/api/v1/user/profile', { terms_of_use: true });

          this.showTermsOfUseModal = false;
        } catch (e) {
          //
        }
      }
    }
    
  };

</script>
